/* SAMPLE COLLECTORS */
export const GET_DISCOUNT_LABHAZIRS = "GET_DISCOUNT_LABHAZIRS";
export const GET_DISCOUNT_LABHAZIRS_SUCCESS =
  "GET_DISCOUNT_LABHAZIRS_SUCCESS";
export const GET_DISCOUNT_LABHAZIRS_FAIL = "GET_DISCOUNT_LABHAZIRS_FAIL";

export const UPDATE_DISCOUNT_LABHAZIR = "UPDATE_DISCOUNT_LABHAZIR";
export const UPDATE_DISCOUNT_LABHAZIR_SUCCESS =
  "UPDATE_DISCOUNT_LABHAZIR_SUCCESS";
export const UPDATE_DISCOUNT_LABHAZIR_FAIL =
  "UPDATE_DISCOUNT_LABHAZIR_FAIL";

export const UPDATE_DISCOUNT_ALL_LABHAZIR = "UPDATE_DISCOUNT_ALL_LABHAZIR";
export const UPDATE_DISCOUNT_ALL_LABHAZIR_SUCCESS =
  "UPDATE_DISCOUNT_ALL_LABHAZIR_SUCCESS";
export const UPDATE_DISCOUNT_ALL_LABHAZIR_FAIL =
  "UPDATE_DISCOUNT_ALL_LABHAZIR_FAIL";

